import { connect } from 'react-redux';

import { ManageTagModal } from '../../components/modals/manage-tags-modal';
import Global from '../../store/global-selectors';

const mapStateToProps = (state) => {
  const tags = Global.selectSellerTags(state);
  return {
    tags,
  };
};

export const ManageTagsModalContainer = connect(mapStateToProps)(ManageTagModal);
